(function () {
  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    var root = document.querySelector('[data-password-gate]');
    if (!root) return;

    var form = root.querySelector('form');
    if (!form) return;

    var input = root.querySelector('[data-password-input]');
    var errorEl = root.querySelector('[data-password-error]');
    var submit = root.querySelector('[data-password-submit]');
    var shell = root.querySelector('[data-password-field]');
    var ink = root.querySelector('[data-password-ink]');
    if (!input || !submit || !shell) return;

    var emptyMsg = root.dataset.emptyError || 'PASSWORD REQUIRED';
    var serverMsg = root.dataset.serverErrorMessage || 'WRONG PASSWORD';
    var submitText = submit.querySelector('.password-gate__submit-text');
    var checkingLabel = root.dataset.checkingLabel || 'CHECKING';
    var shakeTimer;

    function setInkScale() {
      var maxLen = 32;
      var len = Math.min(input.value.length, maxLen);
      var scale = len ? len / maxLen : 0;
      if (ink) ink.style.setProperty('--password-ink-scale', String(scale));
      form.classList.toggle('password-gate__form--typing', len > 0);
    }

    function shake() {
      shell.classList.remove('password-gate__field-shell--shake');
      void shell.offsetWidth;
      shell.classList.add('password-gate__field-shell--shake');
      clearTimeout(shakeTimer);
      shakeTimer = setTimeout(function () {
        shell.classList.remove('password-gate__field-shell--shake');
      }, 520);
    }

    function showError(message) {
      if (errorEl) errorEl.textContent = message;
      form.classList.add('password-gate__form--error');
      input.setAttribute('aria-invalid', 'true');
      shake();
      input.focus();
    }

    function clearError() {
      form.classList.remove('password-gate__form--error');
      input.removeAttribute('aria-invalid');
      if (errorEl && !root.querySelector('[data-password-server-error]')) errorEl.textContent = '';
    }

    input.addEventListener('input', function () {
      root.querySelector('[data-password-server-error]')?.remove();
      clearError();
      setInkScale();
    });

    form.addEventListener('submit', function (event) {
      if (!input.value.trim()) {
        event.preventDefault();
        showError(emptyMsg);
        return;
      }

      form.classList.add('password-gate__form--submitting');
      submit.disabled = true;
      if (submitText) submitText.textContent = checkingLabel;
      else submit.textContent = checkingLabel;
    });

    setInkScale();

    if (root.querySelector('[data-password-server-error]')) {
      showError(serverMsg);
    }
  });
})();
